import { render, staticRenderFns } from "./Icofont.vue?vue&type=template&id=9411f9be&"
import script from "./Icofont.vue?vue&type=script&lang=js&"
export * from "./Icofont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports